<div class="wrapper-subscription-plans-page">
  <span class="title-settings-page"> {{'SETTINGS.subscription_plans' | translate}}</span>
  <div class="wrapper-subscription-plan">
    <span class="label-subscription-plan"> {{'SUBSCRIPTION_PLANS.current_plan' | translate}}</span>
    <div *ngIf="selectedPlan" (click)="clickOnPlan.emit(selectedPlan)" class="wrapper-plan-card" [ngClass]="selectedPlan.roleDB === UserRoles.freemium ? 'free-plan selected' : 'pay-plan selected'">
      <span class="title-plan-card">{{selectedPlan.role}}</span>
      <p *ngIf="selectedPlan.roleDB === UserRoles.freemium">{{selectedPlan.amount}}</p>
      <p *ngIf="selectedPlan.roleDB !== UserRoles.freemium"><span>{{selectedPlan.amount}} </span>/  {{'NEW_TEXT.month' | translate}}</p>
      <div *ngFor="let offer of selectedPlan.offerWhenActivePlan" class="wrapper-feature-plan">
        <div class="feature-plan">
          <div class="wrapper-feature-circle">
            <div class="feature-circle"></div>
            <img *ngIf="selectedPlan.roleDB !== UserRoles.freemium" src="../../../../../assets/icons/outline/icon-check.svg" alt="">
          </div>
          <span>{{offer}}</span>
        </div>
      </div>
      <button (click)="handleSubscription($event, selectedPlan, true)" *ngIf="!currentPlan?.cancel_at_period_end && selectedPlan.btnTextWhenActivePlan" class="custom-btn custom-btn--primary">
        <span>{{selectedPlan.btnTextWhenActivePlan}}</span>
      </button>
      <div class="wrapper-circle-corner">
        <div class="circle-corner"></div>
      </div>
      <p *ngIf="currentPlan?.cancel_at_period_end">You will have all features until your subscription ends on  {{ currentPlan?.current_period_end * 1000 | date: 'MMMM d, yyyy' }}</p>
    </div>
    <span *ngIf="availablePlans.length" class="label-subscription-plan">Avaiable plans</span>
    <div *ngFor="let availablePlan of availablePlans" (click)="clickOnPlan.emit(availablePlan)" class="wrapper-plan-card" [ngClass]="availablePlan.roleDB === UserRoles.freemium ? 'free-plan' : 'pay-plan'">
      <span class="title-plan-card">{{availablePlan.role}}</span>
      <p *ngIf="availablePlan.roleDB === UserRoles.freemium">{{availablePlan.amount}}</p>
      <p *ngIf="availablePlan.roleDB !== UserRoles.freemium"><span>{{availablePlan.amount}} </span>/  {{'NEW_TEXT.month' | translate}}</p>
      <div *ngFor="let offer of availablePlan.offerWhenActivePlan" class="wrapper-feature-plan">
        <div class="feature-plan">
          <div class="wrapper-feature-circle">
            <div class="feature-circle"></div>
            <img *ngIf="availablePlan.roleDB !== UserRoles.freemium" src="../../../../../assets/icons/outline/icon-check.svg" alt="">
          </div>
          <span>{{offer}}</span>
        </div>
      </div>
      <button (click)="handleSubscription($event, availablePlan)" class="custom-btn" [ngClass]="availablePlan.roleDB === UserRoles.freemium ? 'custom-btn--yellow' : 'custom-btn--primary'">
        <span>{{availablePlan.btnText}}</span>
      </button>
      <div class="wrapper-circle-corner">
        <div class="circle-corner"></div>
      </div>
    </div>
  </div>
</div>
